import { render } from "./AddInverterPage.vue?vue&type=template&id=b8cc10de"
import script from "./AddInverterPage.vue?vue&type=script&lang=js"
export * from "./AddInverterPage.vue?vue&type=script&lang=js"

import "./AddInverterPage.vue?vue&type=style&index=0&id=b8cc10de&lang=css"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__